import { Clock, CreditCard, Bus } from 'lucide-react';

interface GondolaSectionProps {
  onShowBusSchedule: () => void;
}

export function GondolaSection({ onShowBusSchedule }: GondolaSectionProps) {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-8">Program & Tarife Telecabina</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Clock className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2">Program</h3>
                  <p className="text-gray-600">
                    Luni - Vineri: 09:00 - 16:30<br />
                    Sâmbătă - Duminică: 09:00 - 16:30
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <CreditCard className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="text-xl font-semibold mb-2">Tarife</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li>O urcare: 45 lei</li>
                    <li>Abonament zilnic: 160 lei</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <button
                onClick={onShowBusSchedule}
                className="text-orange-500 hover:text-orange-600 font-semibold flex items-center gap-2"
              >
                Vezi programul liniei 20
                <Bus className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="relative h-[400px] rounded-xl overflow-hidden">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/nhvelo-f0124.appspot.com/o/NhVeloSite%2FScreenshot%202025-04-25%20at%2010.32.11-min.png?alt=media&token=630e87cf-6671-479a-9dde-e71d2a8231bd"
              alt="Gondola"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}